import { UntypedFormControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';

const URL_REGEX = /^((https?:\/\/)?([\w-]+(\.[\w-]+)+|localhost)\.?(:\d+)?((\/)?\S*)?)$/i;
const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// Following regex matches North American, South African, UK, and Australian phone numbers, with some support for extensions
const PHONE_NUMBER_REGEX =
  /(^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$)|(^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?#(\d{4}|\d{3}))?$)|(^(\+\d{2}[ -]{0,1}){0,1}(((\({0,1}[ -]{0,1})0{0,1}\){0,1}[2|3|7|8]{1}\){0,1}[ -]*(\d{4}[ -]{0,1}\d{4}))|(1[ -]{0,1}(300|800|900|902)[ -]{0,1}((\d{6})|(\d{3}[ -]{0,1}\d{3})))|(13[ -]{0,1}([\d -]{5})|((\({0,1}[ -]{0,1})0{0,1}\){0,1}4{1}[\d -]{8,10})))$)|((\(0\d\d\)\s\d{3}[\s-]+\d{4})|(0\d\d[\s-]+\d{3}[\s-]+\d{4})|(0\d{9})|(\+\d\d\s?[(\s]\d\d[)\s]\s?\d{3}[\s-]?\d{4}))|((0*49[0-9]{10,}$)|(\+49[\s0-9]{10,}$))/;
const ZIP_POSTAL_CODE_REGEX = /(^[A-Y]\d[A-Z]( )?\d[A-Z]\d$)|(^\d{5}(-\d{4})?$)|(^\d{4}$)/;
const INVALID_NAME_REGEX = /[&*@#%^(),;]/;
const MAX_NAME_LENGTH = 64;

export class Validator {
  static isUrl(control: UntypedFormControl): any {
    if (control.value && control.value.match(URL_REGEX)) {
      return null;
    } else if (control.value) {
      return { invalidUrl: true };
    }
  }

  static isEmail(control: UntypedFormControl): any {
    if (control.value && control.value.match(EMAIL_REGEX)) {
      return null;
    } else if (control.value) {
      return { invalidEmail: true };
    }
  }

  static isPhoneNumber(control: UntypedFormControl): any {
    if (control.value && control.value.match(PHONE_NUMBER_REGEX)) {
      return null;
    } else if (control.value) {
      return { invalidPhoneNumber: true };
    }
  }

  static isZipOrPostalCode(control: UntypedFormControl): any {
    if (control.value && control.value.match(ZIP_POSTAL_CODE_REGEX)) {
      return null;
    } else if (control.value) {
      return { invalidZipCode: true };
    }
  }

  static isName(control: UntypedFormControl): any {
    if (control.value) {
      if (control.value.includes(',') || control.value.includes(';')) {
        return { invalidName: true };
      }
    }
    return null;
  }

  static isCustomerName(control: UntypedFormControl): any {
    if (control.value) {
      if (control.value.length > MAX_NAME_LENGTH) {
        return { nameTooLong: true };
      }

      if (control.value.match(INVALID_NAME_REGEX)) {
        return { invalidName: true };
      }
    }
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static errorMessage(validatorName: string, validatorValue?: any): string {
    const config = {
      required: 'COMMON.VALIDATIONS.REQUIRED',
      invalidEmail: 'COMMON.VALIDATIONS.INVALID_EMAIL',
      invalidPhoneNumber: 'COMMON.VALIDATIONS.INVALID_PHONE_NUMBER',
      invalidZipCode: 'COMMON.VALIDATIONS.INVALID_ZIP_CODE',
      invalidUrl: 'COMMON.VALIDATIONS.INVALID_URL',
    };

    return (config as any)[validatorName];
  }

  static getFormError(formGroup: UntypedFormGroup): string {
    let errorMessage = null;
    Object.keys(formGroup.controls).forEach((key) => {
      const formError: ValidationErrors = formGroup.get(key).errors;
      if (formError !== null) {
        errorMessage = Validator.errorMessage(Object.keys(formError)[0]);
      }
    });
    return errorMessage;
  }
}
